export default "__VITE_ASSET__1b62f69c__"